import { useAtomValue, useSetAtom } from "jotai";
import { renderFromToTimeString } from "../../utils/date";
import SlotComponent from "./SlotComponent";
import { listingGuidAtom, passengersAtom, selectedSeasonAtom } from "./store";
import { CalendarDayPriceResult, Query } from "@repo/rq-api-public";
import { useBookingStartDateTime, useDebounce } from "../hooks";
import { TimeOnly, TimeSpan } from "@repo/rq-api";

interface CalendarDaySlotProps {
  season: CalendarDayPriceResult;
  selectedDate: Date;
  handleNextStep: () => void;
  currency?: string;
  locale?: string;
}

export default function CalendarDaySlot({
  season,
  selectedDate,
  handleNextStep,
  currency,
  locale,
}: CalendarDaySlotProps) {
  const passengers = useAtomValue(passengersAtom);
  const debouncedPassengers = useDebounce(passengers);
  const setSelectedSeason = useSetAtom(selectedSeasonAtom);
  const startDateTime = useBookingStartDateTime();
  const listingGuid = useAtomValue(listingGuidAtom);

  const { data: calculation, isLoading } =
    Query.usePricingsCalculateCalendarGETQuery(
      {
        listingGuid: listingGuid!,
        startDate: selectedDate,
        startTime: "00:00" as any, // todo remove any
        endDate: selectedDate,
        endTime: "23:59" as any,
        passengers: debouncedPassengers ?? undefined,
        promoCodeStartDateTime: startDateTime,
      },
      {
        enabled: !!listingGuid,
      },
    );

  const handleBook = () => {
    setSelectedSeason(season);
    handleNextStep();
  };

  return (
    <SlotComponent
      title="Full Day"
      fromToTime="8 Hrs"
      price={calculation?.totalPriceWithoutOnlineCustomerFee}
      handleBook={handleBook}
      disabled={!season.isAvailable}
      loading={isLoading}
      currency={currency}
      locale={locale}
    />
  );
}
